"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Chrome_1 = require("react-color/lib/components/chrome/Chrome");
var withStyles_1 = require("../../decorators/withStyles");
var PickerDialog = /** @class */ (function (_super) {
    tslib_1.__extends(PickerDialog, _super);
    function PickerDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PickerDialog.prototype.render = function () {
        var _a = this.props, value = _a.value, onDismiss = _a.onDismiss, onChange = _a.onChange, classes = _a.classes;
        return (React.createElement("div", { className: classes.wrapper },
            React.createElement("div", { className: classes.container },
                React.createElement("div", { className: classes.position, onClick: onDismiss }),
                React.createElement(Chrome_1.default, { color: value, onChange: onChange }))));
    };
    PickerDialog = tslib_1.__decorate([
        withStyles_1.WithStyles({
            wrapper: {
                position: 'relative',
            },
            container: {
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 2
            },
            position: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        })
    ], PickerDialog);
    return PickerDialog;
}(React.PureComponent));
exports.default = PickerDialog;
//# sourceMappingURL=PickerDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Color/PickerDialog.js
// module id = 924
// module chunks = 58